import { useTranslation } from "react-i18next";
import { z } from "zod";
import { type IBillData } from "@services/overview/types";

export const useEditServiceProviderSettingsModalSchema = (
  billData: IBillData,
) => {
  const { t } = useTranslation();

  return z.object({
    ...(billData.canEditServiceProviderDisplayName
      ? {
          displayName: z.string({
            required_error: t("common.form.field.errors.required"),
          }),
        }
      : {}),
    ...(billData.canEditServiceProviderCustomerCode
      ? {
          customerCode: z.string().optional(),
        }
      : {}),
    ...(billData.canIbanNumberBeEdited
      ? {
          ibanNumber: z.string().optional(),
        }
      : {}),
    dueDay: z.number().optional(),
  });
};
